import { apiGetHistoryRate } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_avg_rate: 'evaluation/set_avg_rate',
    set_evaluation_list: 'evaluation/set_evaluation_list',
    set_countdown: 'evaluation/set_countdown',
    set_tanant: 'evaluation/set_tanant',
}

// count state 必須是 Object
const state = {
    avgRate: '',
    evaluationList: [],
    countdown: '',
    tanant: ''
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_AVG_RATE: (state) => {
        return state.avgRate
    },
    GET_EVALUATION_LIST: (state) => {
        return state.evaluationList
    },
    GET_COUNTDOWN: (state) => {
        return state.countdown
    },
    GET_TANANT: (state) => {
        return state.tanant
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getHistoryRate ( {commit} , data ) {
        return new Promise((resolve, reject) => {
            // let data = {
            //     tenantCid: 249,
            //     tenantName: "EddieLandlord"
            // }
            apiGetHistoryRate(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.userRateHistory
                    commit(types.set_evaluation_list, value);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setAvgRate ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_avg_rate, value);
            resolve()
        })
    },
    setEvaluationList ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_evaluation_list, value);
            resolve()
        })
    },
    setCountdown ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_countdown, value);
            resolve()
        })
    },
    setTanant ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_tanant, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_evaluation_list](state, data){
        state.evaluationList = data
    },
    [types.set_avg_rate](state, data){
        state.avgRate = data
    },
    [types.set_countdown](state, data){
        state.countdown = data
    },
    [types.set_tanant](state, data){
        state.tanant = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/evaluation.js